import script from "./tagListBox.vue?vue&type=script&setup=true&lang=js"
export * from "./tagListBox.vue?vue&type=script&setup=true&lang=js"

import "./tagListBox.vue?vue&type=style&index=0&id=a4c5c05e&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a4c5c05e"]])

export default __exports__